import React, { useRef, useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalUserHasPasswordBlock() {
  const { t } = useTranslation();

  const {
    updateShowModalUserHasPasswordBlock,
    updateFocusOnMainScreen,
    logoutUser,
    updateShowUserInfo,
    updatePrint,
    resetTransactions,
    updateReceiptToPrint,
    updateIsCard,
    updateIsCash,
    updatePayCard,
    updatePayCash,
    updatePaySpillerkonto,
    updateChange,
    updatePaymentType,
    updateIsPaymentOpen,
    updateIsSellerOpen,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserLogin,
    updateUserInfo,
    updateIsFastUserLogin,
    updateIsAnonUser,
    updateIsHybridUser,
    updateIsFullUser,
    updateUserParent,
    updateUserChildren,
    updateUserSiblings,
    resetTicketsCH,
    updateTotal,
    updateIsIdentityConfirmed,
    userInfo,
    parentInfo,
    session,
    updateIsLoadingScreen,
    updateShowModalConfirmIdentity,
    updateDisableSellForUser,

    updateIsNeedConfirmation,
    updateShowModalPictureVerificationWarning,
    updateIsPictureVerificationNeeded,
    updateIsVerificationNeeded,
    updateShowModalIsVerificationNeeded,
  } = useContext(AppContext);

  const [isUnlocked, setIsUnlocked] = useState(false);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleUnlockUserPassword = (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      setIsUnlocked(true);
    };

    socket.on('unlockUserPassword', handleUnlockUserPassword);
    return () => {
      socket.off('unlockUserPassword', handleUnlockUserPassword);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handleCancel = async () => {
    updateFocusOnMainScreen(true);
    updateShowModalUserHasPasswordBlock(false);

    if (
      (parentInfoRef.current &&
        (!parentInfoRef.current['Verification method'] ||
          !parentInfoRef.current['SSN ID'])) ||
      (!parentInfoRef.current &&
        (!userInfoRef.current['Verification method'] ||
          !userInfoRef.current['SSN ID']) &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current.username.startsWith('hybrid'))
    ) {
      updateIsVerificationNeeded(true);
      updateShowModalIsVerificationNeeded(true);
      return;
    }

    //* IMAGE VERIFICATION
    if (
      (parentInfoRef.current &&
        !parentInfoRef.current['Verification image ID'] &&
        !parentInfoRef.current['Disabled login reason']) ||
      (!parentInfoRef.current &&
        !userInfoRef.current['Verification image ID'] &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current['Disabled login reason'])
    ) {
      updateIsPictureVerificationNeeded(true);
      if (
        userInfoRef.current &&
        !parentInfoRef.current &&
        userInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      if (
        parentInfoRef.current &&
        parentInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      updateShowModalPictureVerificationWarning(true);
      updateIsNeedConfirmation(true);
      return;
    }

    updateShowModalConfirmIdentity(true);
  };

  const handleConfirm = async () => {
    socket.emit('unlockUserPassword', {
      session: sessionRef.current,
      userInfo: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current,
    });
    updateIsLoadingScreen(true);
  };

  const handleConfirmExit = async () => {
    updateDisableSellForUser(false);
    updateFocusOnMainScreen(true);
    updateShowModalUserHasPasswordBlock(false);

    if (
      (parentInfoRef.current &&
        (!parentInfoRef.current['Verification method'] ||
          !parentInfoRef.current['SSN ID'])) ||
      (!parentInfoRef.current &&
        (!userInfoRef.current['Verification method'] ||
          !userInfoRef.current['SSN ID']) &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current.username.startsWith('hybrid'))
    ) {
      updateIsVerificationNeeded(true);
      updateShowModalIsVerificationNeeded(true);
      return;
    }

    //* IMAGE VERIFICATION
    if (
      (parentInfoRef.current &&
        !parentInfoRef.current['Verification image ID'] &&
        !parentInfoRef.current['Disabled login reason']) ||
      (!parentInfoRef.current &&
        !userInfoRef.current['Verification image ID'] &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current['Disabled login reason'])
    ) {
      updateIsPictureVerificationNeeded(true);
      if (
        userInfoRef.current &&
        !parentInfoRef.current &&
        userInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      if (
        parentInfoRef.current &&
        parentInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      updateShowModalPictureVerificationWarning(true);
      updateIsNeedConfirmation(true);
      return;
    }

    updateShowModalConfirmIdentity(true);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          {!isUnlocked ? (
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('sales.userHasPasswordBlockTitle')} </h1>
              <p>{t('sales.userHasPasswordBlockText1')}</p>
              <p>{t('sales.userHasPasswordBlockText2')}</p>

              <div
                className="react-confirm-alert-button-group"
                style={{ marginTop: '55px' }}
              >
                <button
                  className="btn-custom-yes"
                  onClick={() => {
                    handleConfirm();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.confirm')}
                </button>
                <button
                  className="btn-custom-no"
                  onClick={() => {
                    handleCancel();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CancelIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.cancel')}
                </button>
              </div>
            </div>
          ) : (
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('sales.userHasPasswordUnblockTitle')} </h1>
              <p>{t('sales.userHasPasswordUnblockText')}</p>

              <div
                className="react-confirm-alert-button-group"
                style={{ marginTop: '55px' }}
              >
                <button
                  className="btn-custom-yes"
                  onClick={() => {
                    handleConfirmExit();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.confirm')}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalUserHasPasswordBlock;
